// Removed incorrect import of Error icon
import { soulApi } from "../api/SoulApi";
import { PaymentDataModel } from "../models/Soul/PaymentDataModel";
import {
  SoulDataModel,
  UpdateSoulInfoPayload,
} from "../models/Soul/SoulDataModel";

class SoulManager {
  private static instance: SoulManager;

  public static get(): SoulManager {
    if (!this.instance) {
      this.instance = new SoulManager();
    }
    return this.instance;
  }

  async getSoul(): Promise<SoulDataModel | undefined> {
    try {
      const result = await soulApi.soulInfo.request(null);
      return new SoulDataModel(result.data);
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }

  async updateSoulInfo(
    payload: UpdateSoulInfoPayload
  ): Promise<SoulDataModel | undefined> {
    try {
      const result = await soulApi.updateSoulInfo.request(payload);
      return new SoulDataModel(result.data);
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }

  async getAllSouls(): Promise<SoulDataModel[] | undefined> {
    try {
      const result = await soulApi.allSoulsInfo.request(null);
      const soulsArray = Array.isArray(result.data)
        ? result.data
        : [result.data];
      const mappedSouls = soulsArray.map(
        (item: any) => new SoulDataModel(item)
      );
      return mappedSouls;
    } catch (error) {
      console.error("❌ Error en getAllSouls:", error);
      return undefined;
    }
  }

  async getAllPayments(): Promise<PaymentDataModel[] | undefined> {
    try {
      const result = await soulApi.allPaymentsInfo.request(null);
      const soulsArray = Array.isArray(result.data)
        ? result.data
        : [result.data];
      const mappedSouls = soulsArray.map(
        (item: any) => new PaymentDataModel(item)
      );
      return mappedSouls;
    } catch (error) {
      console.error("❌ Error en getAllPayments:", error);
      return undefined;
    }
  }
}

export const soulManager = SoulManager.get();
